(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PavillionController', PavillionController);

    PavillionController.$inject = ['PavillionDetailService', '$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', '$filter', '$localStorage'];

    function PavillionController(PavillionDetailService, $log, AreaService, $rootScope, $translate, CartFactory, $state, $filter, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];


        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.pavillion = {
            squaremeters: 0,
            price: null,
            package: null,
            colors: []
        };

        // FUNCITONS PUBLIC
        vm.packageInfo = openInfo;
        vm.calc = calculateSquaremeters;
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.resetPackage = resetPackage;
        vm.packageChanged = packageChanged;
        vm.goBack = goBack;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.prices.prices);
            translateStandSystems(vm.bookingoptions);
        });

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function goBack() {
            $state.go('area');
        }

        function translateStandSystems(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang] + " - " + value.price.prices[0].title[vm.lang];
                if (value.availableColors !== undefined) {
                    angular.forEach(value.availableColors, function (color) {
                        if (color.colors !== undefined) {
                            angular.forEach(color.colors, function (col) {
                                col.name = col.translations[vm.lang];
                            });
                        }
                    });
                }
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Pavillion').then(successPrices, error);
            AreaService.loadLabels('Pavillion').then(successLabels, error);
            AreaService.loadBookingOptions('Pavillion').then(successBookingOptions, error);
            AreaService.loadCartLabels('Pavillion').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("PavillionController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("PavillionController | Fetching text labels", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('PavillionController | Fetching cart label', response.data);
            vm.pavillion.cartPositionLabel = response.data;
        }

        function successBookingOptions(response) {
            $log.debug("PavillionController | Fetching booking options", response.data);
            vm.bookingoptions = response.data;
            translateStandSystems(vm.bookingoptions);
        }

        function openInfo() {
            $log.debug('PavillionController | Open pavillion detail Information info');
            PavillionDetailService.open(vm.pavillion.package);
        }

        function error(response) {
            $log.debug('PavillionController | ERROR:', data);
        }

        function pageLoaded() {
            if (vm.bookingoptions) {
                return true;
            }
            return false;
        }

        function calculateSquaremeters() {
            $log.debug('PavillionController | Calculate squaremeter');
            vm.pavillion.squaremeters = parseFloat(vm.pavillion.length * vm.pavillion.width);
        }

        function bookArea() {
            $log.debug('PavillionController | Book Pavillion:', vm.pavillion);
            calculateAreaPrice();

            var colors = [];
            angular.forEach(vm.pavillion.colors, function (colorId, partId) {
                colors.push({partId: partId, colorId: colorId});
            });

            var bookingOption = vm.pavillion.package ? vm.pavillion.package.id : null;
            var bookingOptionTitle = vm.pavillion.package ? vm.pavillion.package.title : null;

            var item = {
                type: 'Area',
                areaType: 'Pavillion',
                cartPositionPrice: vm.pavillion.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.pavillion.cartPositionLabel,
                cartPositionBookingOptionTitle: bookingOptionTitle,
                cartPositionId: null,
                price: vm.pavillion.price.id,
                bookingOption: bookingOption,
                length: vm.pavillion.length,
                width: vm.pavillion.width,
                squaremeters: squareMetersToDouble(vm.pavillion.squaremeters),
                bookingOptionColors: colors,
                fields: {
                    suggestions: vm.pavillion.suggestions,
                    weExhibit: vm.pavillion.vehicleDescription,
                    heaviestObject: vm.pavillion.heaviestObject,
                    maxWeightPerSq: vm.pavillion.maxWeightPerSq,
                    ownstand: vm.pavillion.ownstand,
                    requestedStandSystemOffer: vm.pavillion.requestedStandSystemOffer

                },
                id: null
            };

            $localStorage.showSuccessAlert = true;

            CartFactory.addItem(item);
            $state.go('area');
        }

        function resetPackage() {
            vm.pavillion.package = null;
            vm.pavillion.colors = [];
        }

        function squareMetersToDouble(squaremeters) {
            return parseFloat(squaremeters);
        }

        function packageChanged() {
            vm.pavillion.colors = [];
        }

        function calculateAreaPrice() {
            var packagePrice = vm.pavillion.package ? vm.pavillion.package.price.prices[0].price : 0;
            var sq = parseFloat(vm.pavillion.squaremeters);
            vm.pavillion.cartPositionPrice = (sq) * (packagePrice + vm.pavillion.price.price + vm.prices.disposalFee);
            vm.pavillion.cartPositionParent = null;
            $log.debug('PavillionController | Preis der Fläche:', vm.pavillion.cartPositionPrice);
        }

        return vm;
    }
})();

